const twoConnectEn = {
  footerCopyright: "2Connect Távközlési Infrastruktúra és Hálózati Szolgáltatások Kft.",
  urls: {
    aboutInvitech: "https://www.one.hu/onerol",
    forLargeCompanies: "https://www.one.hu/kozep-nagyvallalatok",
    forSmallAndMediumCompanies: "https://www.one.hu/kozep-nagyvallalatok",
    forInstitutions: "https://www.one.hu/kozep-nagyvallalatok/hasznos/invitech-kozbeszerzes",
    businessServices: "https://www.one.hu/kozep-nagyvallalatok",
    infrastructureServices: "https://www.one.hu/kozep-nagyvallalatok",
    news: "https://www.one.hu/hirek-sajtokozlemenyek",
    dataProcessingCode: "https://www.one.hu/adatvedelem#invitech",
    gtc: "https://one.hu/aszf#aszf-invitech",
    certificates: "https://one.hu/aszf#tanusitvany-invitech",
    impress: "https://www.one.hu/jogi-nyilatkozat",
    providerInformation: "https://one.hu/kozep-nagyvallalatok/hasznos/elerhetosegeink",
    dataProtection: "https://www.one.hu/adatvedelem#invitech",
    coServiceOffers: "https://www.one.hu/kozep-nagyvallalatok",
    premiumServices: "https://www.one.hu/kozep-nagyvallalatok",
  },
};

export default twoConnectEn;
